import React from 'react';

import { ChartContent } from '../../../Chart';

const TimeSeriesView = ({
  chartRef,
  options,
  isNoData,
  useSmallNoDataMessage,
  remountKey,
}: {
  chartRef: React.MutableRefObject<any>;
  options: Highcharts.Options;
  isNoData: boolean;
  useSmallNoDataMessage: boolean;
  remountKey: string;
}) => {
  return (
    <ChartContent
      key={remountKey}
      chartRef={chartRef}
      options={options}
      noDataToDisplay={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default TimeSeriesView;
